// extracted by mini-css-extract-plugin
export default {"container":"PaymentWalletInfo_container__mHBGv","infoText":"PaymentWalletInfo_infoText__cxmDD","walletIcon":"PaymentWalletInfo_walletIcon__wiVcT"};